import {
  Button,
  ButtonBase,
  Divider,
  Fade,
  Typography
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { useEffect } from 'react'

import { CounterWithLabel } from '../../../../components/CounterWithLabel'
import { DateRangePicker } from '../../../../components/DatePicker/DateRangePicker'
import { SITE_KEY } from '../../../../helpers/elements'
import { getTranslate } from '../../../../localization'
import calculateRangeOfDays from '../../CalculateRangeOfDays'
import convertDate from '../../ConvertDate'
import SearchWidgetArrivalDate from '../../SearchWidgetArrivalDate'
import SearchWidgetDepartureDate from '../../SearchWidgetDepartureDate'
import SearchWidgetGuests from '../../SearchWidgetGuests'
import SearchWidgetSearchInput from '../../SearchWidgetSearchInput'
import { SearchWidgetProps } from '../SearchWidgetProps'
import useStyles from './SearchWidgetTabletInterface.styles'

const SearchWidgetTabletInterface: React.FC<SearchWidgetProps> = ({
  selectRangeModalIsOpen,
  setSelectRangeModalIsOpen,
  selectNumberOfGuestsModalIsOpen,
  setSelectNumberOfGuestsModalIsOpen,
  dateObject,
  setdateObject,
  guestsNumber,
  setguestsNumber,
  datePickerRef,
  effectFunction,
  guestInfoRef,
  type,
  searchAvailabilityInput,
  options,
  readMode,
  setreadMode,
  setSearchAvailabilityInput,
  loadingForWBSData,
  bookingRedirect,
  setBookingRedirect,
  selectingStartDate,
  setSelectingStartDate,
  isFromBooking
}) => {
  const classes = useStyles()

  useEffect(
    () => effectFunction(),
    [
      datePickerRef,
      selectRangeModalIsOpen,
      selectNumberOfGuestsModalIsOpen,
      guestInfoRef
    ]
  )
  const nowDate = new Date()

  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  const range =
    dateObject && dateObject.gregorianStartDate && dateObject.gregorianEndDate
      ? calculateRangeOfDays(
          dateObject && dateObject.gregorianStartDate
            ? dateObject.gregorianStartDate
            : `${nowDate.getFullYear()}-${nowDate.getMonth()}-${nowDate.getDate()}`,

          dateObject && dateObject.gregorianEndDate
            ? dateObject.gregorianEndDate
            : `${tomorrow.getFullYear()}-${tomorrow.getMonth()}-${tomorrow.getDate()}`
        )
      : 1

  const handleSearch = () => {
    const siteKey = SITE_KEY
    const initialReferer = localStorage.getItem('Referer')

    let url = ''

    if (isFromBooking) {
      url = `${bookingRedirect}/${
        searchAvailabilityInput.cityID ? 'city' : 'hotel'
      }/?filter=${encodeURIComponent(
        JSON.stringify(searchAvailabilityInput)
      )}&site-key=${encodeURIComponent(
        siteKey || ''
      )}&initial-referer=${encodeURIComponent(initialReferer || '')}`
    } else {
      url = `${bookingRedirect}/${
        searchAvailabilityInput.cityID ? 'city' : 'hotel'
      }/?filter=${encodeURIComponent(
        JSON.stringify(searchAvailabilityInput)
      )}&site-key=${encodeURIComponent(siteKey || '')}`
    }

    window.location.href = url
  }

  const disabled = !(
    (searchAvailabilityInput.propertyCode ||
      !!searchAvailabilityInput.cityID) &&
    !!dateObject.gregorianEndDate
  )

  return (
    <div className={classes.root}>
      <SearchWidgetSearchInput
        options={options}
        loadingForWBSData={loadingForWBSData}
        searchAvailabilityInput={searchAvailabilityInput}
        setSearchAvailabilityInput={setSearchAvailabilityInput!}
        setBookingRedirect={setBookingRedirect}
      />
      <Divider className={classes.divider} />
      <div className={classes.middlePart}>
        <div
          role="presentation"
          onClick={() => {
            setSelectRangeModalIsOpen(!selectRangeModalIsOpen)
            setSelectingStartDate(true)
          }}>
          <SearchWidgetArrivalDate
            data={convertDate(
              dateObject && dateObject.gregorianStartDate
                ? dateObject.gregorianStartDate
                : `${nowDate.getFullYear()}-${nowDate.getMonth()}-${nowDate.getDate()}`
            )}
            selectingStartDate={selectingStartDate}
          />
        </div>
        <Divider orientation="vertical" className={classes.verticalDivider} />
        <div
          role="presentation"
          onClick={() => {
            setSelectRangeModalIsOpen(!selectRangeModalIsOpen)
            setSelectingStartDate(false)
          }}>
          <SearchWidgetDepartureDate
            data={convertDate(
              dateObject && dateObject.gregorianEndDate
                ? dateObject.gregorianEndDate
                : undefined
              // : `${tomorrow.getFullYear()}-${tomorrow.getMonth()}-${tomorrow.getDate()}`
            )}
            selectingStartDate={selectingStartDate}
          />
        </div>
      </div>
      <Divider className={classes.divider} />
      <div>
        <div
          role="presentation"
          onClick={() => setSelectNumberOfGuestsModalIsOpen(true)}>
          <SearchWidgetGuests guestsNumber={guestsNumber} />
          {selectNumberOfGuestsModalIsOpen && (
            <Fade in={selectNumberOfGuestsModalIsOpen} timeout={500}>
              <div className={classes.guestModal} ref={guestInfoRef}>
                <CounterWithLabel
                  label={getTranslate('Adult')}
                  value={guestsNumber}
                  setValue={setguestsNumber}
                  max={5}
                  min={1}
                />
              </div>
            </Fade>
          )}
        </div>
      </div>
      <div className={classes.btnContainer}>
        <ButtonBase className={classes.btnBase} disabled={disabled}>
          <Button
            variant="contained"
            color="primary"
            disabled={disabled}
            fullWidth
            className={classes.searchButton}
            onClick={() => {
              setreadMode(!readMode)
              handleSearch()
            }}
            endIcon={<SearchIcon className={classes.searchIcon} />}>
            <Typography className={classes.btnText}>
              {getTranslate('Search')}
            </Typography>
          </Button>
        </ButtonBase>
        {selectRangeModalIsOpen && (
          <Fade in={selectRangeModalIsOpen} timeout={500}>
            <div className={classes.dateModal} ref={datePickerRef}>
              <div className={classes.nightContainer}>
                <div>
                  <Typography variant="h3" color="secondary">
                    {range}
                  </Typography>
                </div>
                &nbsp;
                <div>
                  <Typography variant="h4" color="secondary">
                    {getTranslate('nights')}
                  </Typography>
                </div>
              </div>
              <DateRangePicker
                onChange={(date) => {
                  setdateObject(date)
                }}
                dateObject={dateObject}
                type={type}
                onDoneClicked={(event) => {
                  event.stopPropagation()
                  setSelectRangeModalIsOpen(false)
                }}
                selectingStart={selectingStartDate}
                setSelectingStart={setSelectingStartDate}
              />
            </div>
          </Fade>
        )}
      </div>
    </div>
  )
}
export default SearchWidgetTabletInterface
